/* FB | HIZLI SEPETE EKLE v7 (2026-06-11).
   v7 EK: STANDART TEMA BUTONU ANINDA ACILIS. Tema'nin product-form (sepete ekle) submit'inde drawer
   0ms'de acilir + spinner gosterilir; icerik CartAddEvent (cart:update) ile gelince spinner kalkar.
   cart:error veya didError durumunda spinner kapanir + drawer kapanir (hata mesaji butonun altinda).
   Ayrica product-form.js'in __fbFastOpenCartDrawer hook'u tanimlandi (emniyet kemeri).
   v6.1 EK: MORPH STALE-IMAGE FIX. Drawer yeniden cizilirken eski <img> dugumu yeni urunun satirinda
   tekrar kullanilip yeni src yuklenene kadar ~0.2sn ESKI gorseli gosteriyordu. Artik drawer icinde bir
   img'in src/srcset'i DEGISTIGI an gorsel gizlenir, yuklenince (onbellekten aninda) yumusak gosterilir.
   v6 (HIZ): spinner gorsel-bekleme tavani 1300->450ms, on-decode 700->500ms.
   Geri almak icin: snippets/stylesheets.liquid'den fb-fast-atc.js satirini sil. */
(function () {
  'use strict';

  /* === FB HEADER FOUC REVEAL === */
  (function fbHeaderReveal() {
    if (window.__fbHeaderReveal) return;
    window.__fbHeaderReveal = 1;
    var d = document;
    function reveal() {
      var h = d.getElementById('header-component');
      if (!h) return;
      try { h.setAttribute('data-fb-sized', ''); } catch (e) {} /* boyut kapisi emniyet kemeri */
      requestAnimationFrame(function () {
        requestAnimationFrame(function () { h.classList.add('fb-header-ready'); });
      });
    }
    function whenReady() {
      var p = [];
      try {
        if (window.customElements) {
          if (!customElements.get('header-actions')) p.push(customElements.whenDefined('header-actions'));
          if (!customElements.get('cart-icon')) p.push(customElements.whenDefined('cart-icon'));
        }
      } catch (e) {}
      if (p.length) { Promise.all(p).then(reveal); } else { reveal(); }
      setTimeout(reveal, 700);
    }
    if (d.readyState === 'loading') d.addEventListener('DOMContentLoaded', whenReady);
    else whenReady();
    window.addEventListener('load', reveal);
    setTimeout(reveal, 1200);
    d.addEventListener('shopify:section:load', function (e) {
      try {
        if (e.target && (e.target.id === 'header-component' || (e.target.querySelector && e.target.querySelector('#header-component')))) {
          setTimeout(reveal, 50);
        }
      } catch (er) {}
    });
  })();

  if (window.__fbFastAtc) return;
  window.__fbFastAtc = 1;

  /* Bekleme ortusu stili */
  try {
    var st = document.createElement('style');
    st.id = 'fb-fast-atc-style';
    st.textContent = '' +
      'cart-drawer-component.fb-atc-pending .cart-drawer__dialog{position:fixed;}' +
      'cart-drawer-component.fb-atc-pending .cart-drawer__dialog::after{' +
        'content:"";position:absolute;inset:0;z-index:60;' +
        'background:var(--fb-cart-bg-color,var(--color-background,#f5ead8));}' +
      'cart-drawer-component.fb-atc-pending .cart-drawer__dialog::before{' +
        'content:"";position:absolute;top:50%;left:50%;width:30px;height:30px;margin:-15px 0 0 -15px;z-index:61;' +
        'border:2px solid rgba(57,43,28,.22);border-top-color:#392B1C;border-radius:50%;' +
        'animation:fbAtcSpin .65s linear infinite;}' +
      '@keyframes fbAtcSpin{to{transform:rotate(360deg)}}' +
      '@media (prefers-reduced-motion:reduce){cart-drawer-component.fb-atc-pending .cart-drawer__dialog::before{animation:none}}';
    (document.head || document.documentElement).appendChild(st);
  } catch (e) {}

  function drawerComp() { return document.querySelector('cart-drawer-component'); }
  function openDrawer() { var d = drawerComp(); if (d && typeof d.open === 'function') { try { d.open(); } catch (e) {} } }
  function closeDrawer() { var d = drawerComp(); if (d && typeof d.close === 'function') { try { d.close(); } catch (e) {} } }

  /* === v6.1: MORPH STALE-IMAGE FIX === */
  (function preventStaleCartImages() {
    function showImg(im) { im.style.transition = 'opacity .14s ease'; im.style.opacity = '1'; }
    /* v7.6: 60ms TOLERANS - onbellekten aninda gelen gorsel HIC gizlenmez/solmaz. */
    function onChange(im) {
      try {
        if (im.__fbShowT) clearTimeout(im.__fbShowT);
        if (im.__fbHideT) clearTimeout(im.__fbHideT);
        var settled = false;
        var finish = function () {
          if (settled) return; settled = true;
          if (im.__fbHideT) { clearTimeout(im.__fbHideT); im.__fbHideT = null; }
          if (im.style.opacity === '0') { showImg(im); }
        };
        if (im.complete && im.naturalWidth > 0) { settled = true; im.style.opacity = '1'; return; }
        im.__fbHideT = setTimeout(function () {
          im.__fbHideT = null;
          if (!settled) { im.style.transition = 'none'; im.style.opacity = '0'; }
        }, 60);
        im.addEventListener('load', finish, { once: true });
        im.addEventListener('error', finish, { once: true });
        im.__fbShowT = setTimeout(finish, 500);
      } catch (e) {}
    }
    var obs = new MutationObserver(function (muts) {
      for (var i = 0; i < muts.length; i++) {
        var m = muts[i];
        if (m.type === 'attributes' && m.target && m.target.tagName === 'IMG') onChange(m.target);
      }
    });
    function observe() { var d = drawerComp(); if (d) { try { obs.observe(d, { subtree: true, attributes: true, attributeFilter: ['src', 'srcset'] }); } catch (e) {} } }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', observe); else observe();
    setTimeout(observe, 1000);
  })();

  var pendingT = null;
  function setPending(on) {
    var d = drawerComp();
    if (!d) return;
    clearTimeout(pendingT);
    if (on) {
      d.classList.add('fb-atc-pending');
      pendingT = setTimeout(function () { d.classList.remove('fb-atc-pending'); }, 8000);
    } else {
      d.classList.remove('fb-atc-pending');
    }
  }
  function isPending() {
    var d = drawerComp();
    return !!(d && d.classList.contains('fb-atc-pending'));
  }

  function drawerImagesReady(maxWait) {
    return new Promise(function (resolve) {
      var d = drawerComp();
      var dlg = d && d.querySelector('dialog');
      if (!dlg) { resolve(); return; }
      var imgs = Array.prototype.slice.call(dlg.querySelectorAll('img'));
      var pending = imgs.filter(function (im) { return !(im.complete && im.naturalWidth > 0); });
      if (!pending.length) { resolve(); return; }
      var left = pending.length, settled = false;
      function fin() { if (settled) return; settled = true; resolve(); }
      pending.forEach(function (im) {
        var done = function () { if (--left <= 0) fin(); };
        im.addEventListener('load', done, { once: true });
        im.addEventListener('error', done, { once: true });
      });
      setTimeout(fin, maxWait || 450);
    });
  }

  function v250(u) { try { return u + (u.indexOf('?') > -1 ? '&' : '?') + 'width=250'; } catch (e) { return u; } }
  function warmAddedImage(item) {
    return new Promise(function (resolve) {
      try {
        var u = item && (item.image || (item.featured_image && item.featured_image.url));
        if (!u) { resolve(); return; }
        var im = new Image();
        try { im.decoding = 'async'; im.fetchPriority = 'high'; } catch (e) {}
        var done = false;
        var fin = function () { if (done) return; done = true; resolve(); };
        im.onload = function () { if (im.decode) { im.decode().then(fin).catch(fin); } else fin(); };
        im.onerror = fin;
        im.src = v250(u);
        setTimeout(fin, 500);
      } catch (e) { resolve(); }
    });
  }

  function sectionIds() {
    var ids = [];
    document.querySelectorAll('cart-items-component[data-section-id]').forEach(function (c) {
      var id = c.dataset.sectionId;
      if (id && ids.indexOf(id) === -1) ids.push(id);
    });
    return ids;
  }

  /* === STOK LIMITI === */
  var inCart = null;
  function refreshInCart(vid) {
    return fetch('/cart.js', { cache: 'no-store', headers: { Accept: 'application/json' } })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (c) {
        if (!c || !c.items) return;
        var n = 0;
        c.items.forEach(function (it) { if (String(it.variant_id) === String(vid)) n += it.quantity; });
        inCart = n;
      })
      .catch(function () {});
  }
  function limitInfo(btn) {
    var stock = parseInt(btn.getAttribute('data-variant-stock'), 10);
    var track = (btn.getAttribute('data-variant-track') || '').trim();
    var policy = (btn.getAttribute('data-variant-policy') || '').trim();
    if (track === 'shopify' && policy !== 'continue' && !isNaN(stock)) return { stock: stock };
    return null;
  }
  function showMsg(text) {
    try {
      var b = document.querySelector('.fb-buy-buttons');
      if (!b) return;
      var m = document.getElementById('fbAtcLimitMsg');
      if (!m) {
        m = document.createElement('p');
        m.id = 'fbAtcLimitMsg';
        m.setAttribute('role', 'status');
        m.setAttribute('aria-live', 'polite');
        m.style.cssText = 'display:none;margin:8px 4px 0;font-family:Bitter,Georgia,serif;font-size:13px;font-weight:500;line-height:1.5;color:#9B3421;text-align:center;';
        b.appendChild(m);
      }
      m.textContent = text;
      m.style.display = 'block';
      clearTimeout(m._t);
      m._t = setTimeout(function () { m.style.display = 'none'; }, 6000);
    } catch (e) {}
  }

  function primeInCart() {
    var btn = document.getElementById('fbAddToCart');
    if (!btn || !limitInfo(btn)) return;
    var go = function () { refreshInCart(btn.dataset.variantId); };
    try {
      if ('requestIdleCallback' in window) requestIdleCallback(go, { timeout: 2000 });
      else setTimeout(go, 800);
    } catch (e) { setTimeout(go, 800); }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', primeInCart);
  else primeInCart();

  /* v8: SEPET DEGISINCE (silme/adet dahil) stok sayacini tazele -> sepet bosalinca ayni urun tekrar eklenebilir */
  document.addEventListener('cart:update', function () {
    try { var b = document.getElementById('fbAddToCart'); if (b && limitInfo(b)) refreshInCart(b.dataset.variantId); } catch (e) {}
  });

  /* === SILME ORTUSU === */
  window.addEventListener('click', function (e) {
    var t = e.target;
    if (!t || !t.closest) return;
    if (!t.closest('cart-drawer-component')) return;
    var rm = t.closest('.cart-items__remove, cart-remove-button, [ref="removeButton"], a[href*="quantity=0"]');
    if (!rm) return;
    setPending(true);
  }, true);

  document.addEventListener('cart:update', function () {
    if (!isPending()) return;
    requestAnimationFrame(function () {
      requestAnimationFrame(function () {
        drawerImagesReady(450).then(function () { setPending(false); });
      });
    });
  });

  /* === ANA AKIS === */
  document.addEventListener('click', function (e) {
    var btn = e.target && e.target.closest ? e.target.closest('#fbAddToCart') : null;
    if (!btn || btn.disabled) return;

    e.preventDefault();
    e.stopPropagation();
    if (e.stopImmediatePropagation) e.stopImmediatePropagation();

    var lim = limitInfo(btn);
    if (lim && inCart !== null && inCart >= lim.stock) {
      showMsg('Stok durumu nedeniyle bu üründen sepetinize en fazla ' + lim.stock + ' adet ekleyebilirsiniz.');
      return;
    }

    btn.style.opacity = '.7';
    setPending(true);
    openDrawer();

    var ids = sectionIds();
    var body = { id: btn.dataset.variantId, quantity: 1 };
    if (ids.length) {
      body.sections = ids.join(',');
      body.sections_url = window.location.pathname;
    }

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    })
      .then(function (r) {
        return r.json().then(function (data) { return { ok: r.ok, data: data }; });
      })
      .then(function (res) {
        btn.style.opacity = '';
        if (!res.ok || res.data.status) {
          setPending(false);
          closeDrawer();
          var msg = (res.data && (res.data.description || res.data.message)) || 'Ürün sepete eklenemedi. Lütfen tekrar deneyin.';
          showMsg(msg);
          if (lim) refreshInCart(btn.dataset.variantId);
          return;
        }

        if (lim && typeof res.data.quantity === 'number') inCart = res.data.quantity;

        warmAddedImage(res.data).then(function () {
          document.dispatchEvent(new CustomEvent('cart:update', {
            detail: {
              resource: undefined,
              sourceId: 'fb-fast-atc',
              data: { source: 'fb-fast-atc', itemCount: res.data.quantity, sections: res.data.sections || {} }
            },
            bubbles: true,
            cancelable: true
          }));
        });
      })
      .catch(function (err) {
        btn.style.opacity = '';
        setPending(false);
        closeDrawer();
        showMsg('Bağlantı sorunu: ürün sepete eklenemedi. Lütfen tekrar deneyin.');
        try { console.error('[fb-fast-atc]', err); } catch (e2) {}
      });
  }, true);

  /* === v7: STANDART SEPETE EKLE -> ANINDA DRAWER + SPINNER === */
  document.addEventListener('submit', function (e) {
    try {
      var form = e.target;
      if (!form || !form.matches || !form.matches('form[data-type="add-to-cart-form"]')) return;
      var pf = form.closest('product-form-component');
      if (!pf) return;
      var qs = pf.refs && pf.refs.quantitySelector;
      if (qs && typeof qs.canAddToCart === 'function') {
        var v = qs.canAddToCart();
        if (v && v.canAdd === false) return;
      }
      setPending(true);
      openDrawer();
      /* v7.6: eklenen urunun SEPET BOYUTUNDAKI (width=250) gorselini fetch daha donmeden isit */
      try {
        var med = pf.querySelector('add-to-cart-component[data-product-variant-media]');
        var mu = med && med.getAttribute('data-product-variant-media');
        if (mu) {
          var wu = /([?&])width=\d+/.test(mu) ? mu.replace(/([?&])width=\d+/, '$1width=250') : mu + (mu.indexOf('?') > -1 ? '&' : '?') + 'width=250';
          var wim = new Image();
          wim.decoding = 'async';
          try { wim.fetchPriority = 'high'; } catch (e3) {}
          wim.src = wu;
        }
      } catch (e2) {}
    } catch (err) {}
  }, true);

  /* v7: sunucu hatasi -> spinner kapat + drawer kapat */
  document.addEventListener('cart:error', function () {
    if (!isPending()) return;
    setPending(false);
    closeDrawer();
  });
  document.addEventListener('cart:update', function (e) {
    try {
      if (e && e.detail && e.detail.data && e.detail.data.didError && isPending()) {
        setPending(false);
        closeDrawer();
      }
    } catch (err) {}
  });

  /* v7: product-form.js hook'u (emniyet kemeri) */
  window.__fbFastOpenCartDrawer = function () {
    try { openDrawer(); } catch (e) {}
  };

  /* === v7.4: SEPET IKONU ANINDA ACILIS === */
  var fbCartPdT = 0;
  document.addEventListener('pointerdown', function (e) {
    try {
      var t = e.target;
      if (!t || !t.closest) return;
      var trg = t.closest('[data-testid="cart-drawer-trigger"]');
      if (!trg) return;
      fbCartPdT = Date.now();
      openDrawer();
    } catch (err) {}
  }, true);

  /* v7.5 FIX (acilip geri kapanma) + v7.9 PC KOK FIX:
     pointerdown ile acilis sonrasi AYNI hareketin 'hayalet' click'i drawer'i kapatiyordu.
     PC'de fare basili tutulurken drawer ACILDIGI icin (pointerdown -> rAF showModal -> pointerup)
     click'in target'i pointerdown(tetikleyici) ile pointerup(acilan modal) dugumlerinin ORTAK
     ATASINA = <cart-drawer-component>'e duser. Eski kosul yalnizca (e.target === dlg || tetikleyici)
     baktigi icin bu durumu KACIRIYORDU -> hayalet click dialog.js'in click-outside'ina ulasip
     drawer'i KAPATIYORDU. (Mobilde dokunus rAF'tan once bittigi icin click-outside henuz baglanmamis
     oluyor, o yuzden mobilde sorun gorunmuyordu.)
     KOK COZUM: acilis penceresi (700ms) icinde, drawer ICERIGINE yapilan GERCEK tiklamalar
     (hedef dialog'un bir cocugu) HARIC her click hayalet kabul edilip yutulur. Boylece icerik
     tiklamalari (adet +/-, checkout, kaldir) AYNEN calisir; hayalet click (ortak-ata/backdrop/
     tetikleyici/disari) drawer'i kapatamaz. Tek bir click yutulur (fbCartPdT sifirlanir),
     700ms sonra backdrop ile kapatma normal calisir. */
  document.addEventListener('click', function (e) {
    try {
      if (!fbCartPdT) return;
      if (Date.now() - fbCartPdT > 700) { fbCartPdT = 0; return; }
      var d = drawerComp();
      var dlg = d && d.querySelector('dialog');
      if (!dlg) { fbCartPdT = 0; return; }
      var insideContent = !!(e.target && dlg.contains(e.target) && e.target !== dlg);
      if (!insideContent) {
        fbCartPdT = 0;
        e.preventDefault();
        e.stopPropagation();
        if (e.stopImmediatePropagation) e.stopImmediatePropagation();
      }
    } catch (err) {}
  }, true);

  /* === v7.1/7.2/7.3: ANINDA GERI BILDIRIM (adet +/- & header ikonlari; KOF efekti yok) === */
  (function fbInstantFeedback() {
    try {
      var st2 = document.createElement('style');
      st2.id = 'fb-instant-feedback-style';
      st2.textContent = '' +
        'cart-drawer-component text-component[shimmer]{animation-delay:-.28s!important;}' +
        'cart-drawer-component quantity-selector-component button:active:not([disabled]),' +
        'cart-drawer-component cart-quantity-selector-component button:active:not([disabled]){transform:scale(.93);transition:transform .06s ease;}' +
        '.header-actions__action:active .svg-wrapper,.header-actions__action:active svg,.header-actions__cart-icon:active svg{transform:scale(.88);transition:transform .06s ease;}' +
        '.header-actions__action:active,.header-actions__cart-icon:active{opacity:.75;}';
      (document.head || document.documentElement).appendChild(st2);
    } catch (e) {}

    document.addEventListener('click', function (e) {
      try {
        var t = e.target;
        if (!t || !t.closest) return;
        var qsBtn = t.closest('cart-drawer-component quantity-selector-component button, cart-drawer-component cart-quantity-selector-component button');
        if (!qsBtn || qsBtn.disabled) return;
        var row = qsBtn.closest('.cart-items__table-row');
        var dlg = qsBtn.closest('dialog');
        var targets = [];
        if (row) { var tc = row.querySelector('text-component'); if (tc) targets.push(tc); }
        if (dlg) { var tot = dlg.querySelector('[ref="cartTotal"]') || dlg.querySelector('.cart-drawer__summary text-component'); if (tot) targets.push(tot); }
        for (var i = 0; i < targets.length; i++) {
          var el = targets[i];
          if (typeof el.shimmer === 'function') { try { el.shimmer(); } catch (e2) { el.setAttribute('shimmer', ''); } }
          else { el.setAttribute('shimmer', ''); }
        }
      } catch (err) {}
    }, true);
  })();

  /* === v7.8: URUN ACIKLAMASI EMOJI RESTORASYONU + TABLO ISARETLEME ===
     'aciklama gosterici' (V6.1, sablon icinde gomulu) emoji-yalniz dugumleri siliyor ve
     bozuk yapistirilan tablolarin stilleri kayip. Kod sablonda gomulu oldugundan DISARIDAN
     tamamlanir:
     1) EMOJI: V6.1'in kendi kaynagi #fbProdDescJSON'daki ORIJINAL aciklamadan paragraf basi
        emojiler okunur, render edilmis esleniklerinin basina AYNEN geri konur. Uydurma yok,
        sabit emoji yok; her urunun KENDI emojileri. Idempotent, eslesmeyen sessizce atlanir.
     2) TABLO: ayni bolumdeki tum tablolara 'fb-desc-table' sinifi basilir -> stylesheets'teki
        fb-rte-fix kurallari giydirir (cizgiler, ferah Not sutunu). Konteyner adi ne olursa
        olsun, HER urunde calisir. */
  (function fbRestoreDescEmojis() {
    var EMO_LEAD = /^[\s ]*((?:[\u{1F300}-\u{1FAFF}\u{2600}-\u{27BF}\u{FE00}-\u{FE0F}\u{1F000}-\u{1F02F}][︎️]?[\s ]*)+)/u;
    function norm(t) {
      return (t || '').replace(/[\s ]+/g, ' ').trim().toLocaleLowerCase('tr-TR');
    }
    function run() {
      try {
        var src = document.getElementById('fbProdDescJSON');
        if (!src) return;

        /* v7.8: tablolari isaretle (CSS giydirsin) */
        try {
          var sect = src.closest('.shopify-section');
          if (sect) {
            var tbls = sect.querySelectorAll('table');
            for (var ti = 0; ti < tbls.length; ti++) { tbls[ti].classList.add('fb-desc-table'); }
          }
        } catch (e4) {}

        var html = '';
        try { html = JSON.parse(src.textContent || '""') || ''; } catch (e) { return; }
        if (!html) return;
        var doc = new DOMParser().parseFromString(html, 'text/html');
        if (!doc || !doc.body) return;
        var pairs = [];
        var blocks = doc.body.querySelectorAll('p, h1, h2, h3, h4, h5, h6, li, div');
        for (var i = 0; i < blocks.length; i++) {
          var t = (blocks[i].textContent || '').replace(/[\s ]+/g, ' ').trim();
          var m = t.match(EMO_LEAD);
          if (!m) continue;
          var rest = t.slice(m[0].length).trim();
          if (!rest) continue;
          pairs.push({ emo: m[1].replace(/[\s ]+/g, ' ').trim(), key: norm(rest).slice(0, 32) });
        }
        if (!pairs.length) return;
        var targets = document.querySelectorAll('.fb-product-info-v3 p, .fb-product-info-v3 li, .fb-product-info-v3 h1, .fb-product-info-v3 h2, .fb-product-info-v3 h3, .fb-product-info-v3 h4, .fb-product-info-v3 h5, .fb-product-info-v3 h6');
        for (var p = 0; p < pairs.length; p++) {
          var pr = pairs[p];
          if (!pr.key || !pr.emo) continue;
          for (var j = 0; j < targets.length; j++) {
            var el = targets[j];
            if (el.__fbEmoDone) continue;
            var et = norm(el.textContent);
            if (!et || et.indexOf(pr.key) !== 0) continue;
            if ((el.textContent || '').indexOf(pr.emo.charAt(0)) !== -1) { el.__fbEmoDone = true; break; }
            el.insertBefore(document.createTextNode(pr.emo + ' '), el.firstChild);
            el.__fbEmoDone = true;
            break;
          }
        }
      } catch (e) {}
    }
    function go() { setTimeout(run, 50); setTimeout(run, 350); setTimeout(run, 1200); }
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', go, { once: true });
      window.addEventListener('load', function () { setTimeout(run, 250); }, { once: true });
    } else { go(); }
  })();
})();